import PropTypes from 'prop-types';

export const TextFieldDefaultProps = {
  autoComplete: 'off',
  autoFocus: false,
  children: null,
  className: '',
  context: null,
  disabled: false,
  errors: null,
  errorsIcon: null,
  icon: null,
  iconPosition: 'right',
  id: null,
  max: null,
  maxLength: null,
  min: null,
  minLength: null,
  name: '',
  onBlur: () => null,
  onChange: () => null,
  onClick: () => null,
  onFocus: () => null,
  onKeyDown: () => null,
  placeholder: '',
  position: 'top',
  readOnly: false,
  required: false,
  spellCheck: false,
  type: 'text',
  value: '',
};

export const TextFieldPropTypes = {
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  context: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  errorsIcon: PropTypes.element,
  icon: PropTypes.element,
  iconPosition: PropTypes.oneOf(['right', 'left']),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.number,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  minLength: PropTypes.number,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  spellCheck: PropTypes.bool,
  type: PropTypes.oneOf([
    'date',
    'email',
    'hidden',
    'number',
    'password',
    'search',
    'tel',
    'text',
    'time',
    'url',
  ]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
